import React from 'react'
import { DefaultHead } from '../common/Head'
import { Template } from '../common/Template'
import { EnterpriseGuide } from '../atoms/EnterpriseGuide'

export const EnterpriseGuideTemplate: React.FC = () => {
  return (
    <>
      <DefaultHead></DefaultHead>
      <Template>
        <EnterpriseGuide />
      </Template>
    </>
  )
}
